import { createContext } from 'react'

const ConfirmationServiceContext = createContext(Promise.reject)

export default ConfirmationServiceContext
